import VerifyOtpForm from "@/features/auth/login/components/VerifyOtpForm";

export default function EnterOtp() {
  return <VerifyOtpForm />;
}
